@if (updateItems().length > 0) {
  @if (showCard) {
    <!-- Embedded mode with card wrapper -->
    <app-shared-card [additionalClasses]="cardClasses">
      @if (showExpandCollapse) {
        <div [class]="compact ? 'space-y-3 md:space-y-4' : 'space-y-4'">
          <div class="flex justify-between items-center">
            <h3 [class]="compact ? 'text-base md:text-lg font-semibold text-gray-800' : 'text-xl font-semibold text-gray-800'">
              Updates
            </h3>
            @if (hasRemainingUpdates()) {
              <button
                (click)="toggleExpanded()"
                class="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
              >
                @if (isExpanded()) {
                  <lucide-angular [img]="chevronUp" size="14"></lucide-angular>
                  <span class="hidden sm:inline">Weniger anzeigen</span>
                  <span class="sm:hidden">Weniger</span>
                } @else {
                  <lucide-angular [img]="chevronDown" size="14"></lucide-angular>
                  <span class="hidden sm:inline">{{ remainingCount() }} weitere Updates anzeigen</span>
                  <span class="sm:hidden">+{{ remainingCount() }}</span>
                }
              </button>
            }
          </div>

          <!-- Always show latest update -->
          @if (latestUpdate()) {
            <div class="bg-white border border-gray-200 rounded-lg p-3 md:p-4">
              <h4 class="text-sm md:text-medium font-semibold text-gray-800 mb-1">
                {{ latestUpdate()!.title }}
              </h4>

              @if (latestUpdate()!.description) {
                <p class="text-gray-700 text-xs md:text-sm whitespace-pre-line">
                  {{ latestUpdate()!.description }}
                </p>
              }

              <div class="flex flex-col sm:flex-row mt-1.5 md:mt-2 gap-1.5 sm:gap-2">
                <span
                  [class]="
                    'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium flex-shrink-0 ' +
                    (latestUpdate()!.priority === 'Niedrig'
                      ? 'bg-green-100 text-green-800'
                      : latestUpdate()!.priority === 'Mittel'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800')
                  "
                >
                  {{ latestUpdate()!.priority }}
                </span>
                <p class="text-gray-500 text-xs md:text-sm font-semibold">
                  {{ latestUpdate()!.publishedAt | timeAgo }}
                </p>
              </div>
            </div>
          }

          <!-- Show remaining updates when expanded -->
          @if (isExpanded() && hasRemainingUpdates()) {
            <div class="space-y-2 md:space-y-3">
              @for (update of remainingUpdates(); track update.title) {
                <div class="bg-white border border-gray-200 rounded-lg p-3 md:p-4">
                  <h4 class="text-sm md:text-medium font-semibold text-gray-800 mb-1">
                    {{ update.title }}
                  </h4>

                  @if (update.description) {
                    <p class="text-gray-700 text-xs md:text-sm whitespace-pre-line">
                      {{ update.description }}
                    </p>
                  }

                  <div class="flex flex-col sm:flex-row mt-1.5 md:mt-2 gap-1.5 sm:gap-2">
                    <span
                      [class]="
                        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium flex-shrink-0 ' +
                        (update.priority === 'Niedrig'
                          ? 'bg-green-100 text-green-800'
                          : update.priority === 'Mittel'
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-red-100 text-red-800')
                      "
                    >
                      {{ update.priority }}
                    </span>
                    <p class="text-gray-500 text-xs md:text-sm font-semibold">
                      {{ update.publishedAt | timeAgo }}
                    </p>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <!-- Card wrapper without expand/collapse -->
        <div>
          <h3 [class]="compact ? 'text-lg font-semibold text-gray-800 mb-4' : 'text-xl font-semibold text-gray-800 mb-4'">
            Updates
          </h3>
          <ul class="space-y-3">
            @for (update of updateItems(); track update.title) {
              <li>
                <div class="bg-white border border-gray-200 rounded-lg p-4">
                  <h4 class="text-medium font-semibold text-gray-800 mb-1">
                    {{ update.title }}
                  </h4>

                  @if (update.description) {
                    <p class="text-gray-700 text-sm whitespace-pre-line">
                      {{ update.description }}
                    </p>
                  }

                  <div class="flex mt-2 gap-2">
                    <span
                      [class]="
                        'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ' +
                        (update.priority === 'Niedrig'
                          ? 'bg-green-100 text-green-800'
                          : update.priority === 'Mittel'
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-red-100 text-red-800')
                      "
                    >
                      {{ update.priority }}
                    </span>
                    <p class="text-gray-500 text-sm font-semibold">
                      {{ update.publishedAt | timeAgo }}
                    </p>
                  </div>
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </app-shared-card>
  } @else {
    <!-- Original mode without card wrapper -->
    @if (showExpandCollapse) {
      <div [class]="compact ? 'space-y-4' : 'space-y-4'">
        <div class="flex justify-between items-center">
          <h3 [class]="compact ? 'text-lg font-semibold text-gray-800' : 'text-xl font-semibold text-gray-800'">
            Updates
          </h3>
          @if (hasRemainingUpdates()) {
            <button
              (click)="toggleExpanded()"
              class="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
            >
              @if (isExpanded()) {
                <lucide-angular [img]="chevronUp" size="16"></lucide-angular>
                Weniger anzeigen
              } @else {
                <lucide-angular [img]="chevronDown" size="16"></lucide-angular>
                {{ remainingCount() }} weitere Updates anzeigen
              }
            </button>
          }
        </div>

        <!-- Always show latest update -->
        @if (latestUpdate()) {
          <div class="bg-white border border-gray-200 rounded-lg p-4">
            <h4 class="text-medium font-semibold text-gray-800 mb-1">
              {{ latestUpdate()!.title }}
            </h4>

            @if (latestUpdate()!.description) {
              <p class="text-gray-700 text-sm whitespace-pre-line">
                {{ latestUpdate()!.description }}
              </p>
            }

            <div class="flex mt-2 gap-2">
              <span
                [class]="
                  'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ' +
                  (latestUpdate()!.priority === 'Niedrig'
                    ? 'bg-green-100 text-green-800'
                    : latestUpdate()!.priority === 'Mittel'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-red-100 text-red-800')
                "
              >
                {{ latestUpdate()!.priority }}
              </span>
              <p class="text-gray-500 text-sm font-semibold">
                {{ latestUpdate()!.publishedAt | timeAgo }}
              </p>
            </div>
          </div>
        }

        <!-- Show remaining updates when expanded -->
        @if (isExpanded() && hasRemainingUpdates()) {
          <div class="space-y-3">
            @for (update of remainingUpdates(); track update.title) {
              <div class="bg-white border border-gray-200 rounded-lg p-4">
                <h4 class="text-medium font-semibold text-gray-800 mb-1">
                  {{ update.title }}
                </h4>

                @if (update.description) {
                  <p class="text-gray-700 text-sm whitespace-pre-line">
                    {{ update.description }}
                  </p>
                }

                <div class="flex mt-2 gap-2">
                  <span
                    [class]="
                      'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ' +
                      (update.priority === 'Niedrig'
                        ? 'bg-green-100 text-green-800'
                        : update.priority === 'Mittel'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-red-100 text-red-800')
                    "
                  >
                    {{ update.priority }}
                  </span>
                  <p class="text-gray-500 text-sm font-semibold">
                    {{ update.publishedAt | timeAgo }}
                  </p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <!-- Standalone full page mode -->
      <div class="flex flex-col gap-4 pb-[80px]">
        <ul class="space-y-3">
          @for (update of updateItems(); track update.title) {
            <li>
              <app-shared-card>
                <div class="p-4">
                  <h3 class="text-medium font-semibold text-gray-800 mb-1">
                    {{ update.title }}
                  </h3>

                  @if (update.description) {
                    <p class="text-gray-700 text-sm whitespace-pre-line">
                      {{ update.description }}
                    </p>
                  }

                  <div class="flex mt-2 gap-2">
                    <span
                      [class]="
                        'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ' +
                        (update.priority === 'Niedrig'
                          ? 'bg-green-100 text-green-800'
                          : update.priority === 'Mittel'
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-red-100 text-red-800')
                      "
                    >
                      {{ update.priority }}
                    </span>
                    <p class="text-gray-500 text-sm font-semibold">
                      {{ update.publishedAt | timeAgo }}
                    </p>
                  </div>
                </div>
              </app-shared-card>
            </li>
          }
        </ul>
      </div>
    }
  }
}
